module.exports = __webpack_public_path__ + "media/images/sp/stores/sola/instagram/sola_sns_03-0776cfda15eb220433adc6d9ba1c1c1c.jpg";